module.exports = __webpack_public_path__ + "static/media/Icn-sql.e70095c6.svg";